<template>
  <div class="banner">
    <h2>{{ bannerName }}</h2>
  </div>
</template>
<script>
export default {
  name: 'Banner',
  props: {
    bannerName: {
      type: String,
      default: null
    }
  },
}
</script>
<style scoped>
.banner {
  background-color: #f8f8f8;
  border-bottom: 1px solid #6293c2;
  border-top: 3px solid #6293c2;
}

h2 {
  font-size: 28px;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Banner.vue